import { Injectable } from '@angular/core';
import { fiTryContentLanguageValue, getContentWithLanguage } from '@fi-shared/utils/try-content-language-value';
import { fiWidgetGetTextId } from '@fi-shared/widget/widget-registry';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';

@Injectable()
export class WidgetContentService {
    constructor(
        private appTextService: AppTextService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private userDataService: FiUserDataService,
    ) {}

    getContentWithLanguage(Contents, languageId: number) {
        if (this.userDataService.userData)
            return getContentWithLanguage(
                Contents,
                languageId,
                this.userDataService.userData.PreferredContentLanguage,
                this.contentLanguageSharedService.getDefaultContentLanguageId(),
            );
        return '';
    }

    GetHeaderTitle(control, languageId) {
        if (!this.userDataService.userData) {
            return '';
        }
        const defaultLanguage = this.userDataService.userData.PreferredContentLanguage,
            defaultApplicationLanguage = this.contentLanguageSharedService.getDefaultContentLanguageId();

        if (control.Settings.HeaderNames) {
            const headerTitle =
                control.Settings.HeaderNames[languageId] ||
                control.Settings.HeaderNames[defaultLanguage] ||
                control.Settings.HeaderNames[defaultApplicationLanguage];
            if (headerTitle) return headerTitle;
        } else if (control.Names) {
            const title =
                fiTryContentLanguageValue(control.Names, languageId) ||
                fiTryContentLanguageValue(control.Names, defaultLanguage);
            if (title) {
                return title;
            }
        }

        return control.Name || this.appTextService.get(fiWidgetGetTextId(control.WidgetType));
    }
}
